module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"shareable":"Shareable link","personal":"Personal invitation","excel":"Import from Excel"}}')
  delete Component.options._Ctor
}
